<template>
  <div class="mobile-layout-design">
    <LoadingSpinner v-if="loading" />
    <div v-else>
      <InvoiceDesign ref="invoicelayout-design" @updated="updatedDesign"/>
      <div class="btn-savelayout">
        <GekkoButton
          @click="saveChanges()"
          :text="$gettext('Save layout')"
          class="w-100"
          size="lg"
        >
          <template v-slot:premium-badge>
            <GkBadge 
              icon="fa-solid fa-crown"
              icon-only
              type="premium"
              variant="light-ghost"
            />
          </template>
        </GekkoButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import settingsPageSetup from "@/mixins/settingsPageSetup"
import GekkoButton from '@/components/GekkoButton.vue'
import InvoiceDesign from "@/views/settings/InvoiceDesign"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

export default {
  name: 'InvoiceDesignMobile',
  components: {
    GekkoButton,
    InvoiceDesign,
    LoadingSpinner
  },
  mixins: [ settingsPageSetup ],
  data () {
    return {
      loading: false,
      pageSettings: {
        showCompanyPicker: false
      },
      mobile_app_view: null,
    }
  },
  computed:{
    ...mapGetters({ 
      currentCompany: "main/getCurrentCompany",
      preferredLanguage: 'main/getPreferredLanguage',
      getCompanyId: 'main/getCompanyId',
      getMobileAppView: "main/getMobileAppView"
    })
  },
  created () {
    this.mobile_app_view = this.getMobileAppView
    this.setupData()
  },
  methods:{
    ...mapActions({
      getBrandDataAndSelect: 'brands/getBrandDataAndSelect',
    }),
    setupData () {
      if (this.$route.params.brand_id) {
        this.loading = true
        this.getBrandDataAndSelect(this.$route.params.brand_id).then(() => {
          this.$nextTick(() => {
            this.loading = false
          })
        })
      }
    },
    saveChanges () {
      if (!this.currentCompany.is_premium) {
        this.$store.commit('togglePremiumModal', 'web_invoices_design')
      } else {
        this.$refs['invoicelayout-design'].saveChanges()
      }
    },
    updatedDesign () {
      console.log('updatedDesign')
    },
  }
};
</script>

<style lang="scss">
  .main-content.invoicedesignmobile {
    padding: 0 !important;
    .settingstitle {
      display: none;
    }
    .edit-invoice-design-wrap .right-col {
      margin-bottom: 75px;
    }
  }
</style>

<style lang="scss" scoped>
  .mobile-layout-design {
    background: white;
    .btn-savelayout {
      padding: 1rem;
      position: fixed;
      bottom: 0;
      background: white;
      width: 100%;
      border-top: 1px solid $colorBorderDash;
      z-index: 9100;
    }
  }
</style>
